// Define MenuItem class
class MenuItem {
  constructor(element) {
    this.element = element;
    this.itemDetail = this.element.querySelector('details');
    this.itemSummary = this.element.querySelector('summary');
    this.addHoverListener();
  }

  addHoverListener() {
    this.element.addEventListener('mouseenter', () => {
      this.itemDetail.setAttribute('open', 'open');
      this.itemSummary.setAttribute('aria-expanded', 'true');
    });

    this.element.addEventListener('mouseleave', () => {
      this.itemDetail.removeAttribute('open');
      this.itemSummary.setAttribute('aria-expanded', 'false');
    });
  }
}

// Select all header-menu items and create MenuItem instances for each
var menuItems = document.querySelectorAll('header-menu');
menuItems.forEach(item => {
  new MenuItem(item);
});
